import clsx from "clsx";

export default function WidgetShell({ children }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-transparent">
            <main
                data-widget-root
            className={clsx(
                    "w-[460px] h-[620px] rounded-2xl overflow-hidden",
                    "border border-black/10 dark:border-white/10",
                    "shadow-[0_30px_80px_-20px_rgba(0,0,0,0.3)] dark:shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)]",
                    "bg-gradient-to-b",
                    "from-[#f8fafc] via-[#f1f5f9] to-[#e2e8f0]",
                    "dark:from-[#0f172a] dark:via-[#0b1220] dark:to-[#070c16]"
                )}
            >
                {children}
            </main>
        </div>
    );
}
